import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../auth/AuthProvider';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';

export default function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const success = await login(username, password); // Ensure login returns user info or we decode it here
            // We need to know the role to redirect correctly if 'from' is default
            // Since login updates context, we might not have updated 'user' immediately in this component scope 
            // without using the returned value or decoding token again.
            // But AuthProvider.login returns true/false. Let's assume we can get role from token or response.
            // Actually, safe bet is to just let AuthProvider handle it or decode here.
            // Decoding access token to get role immediately for redirection
            const token = localStorage.getItem('access_token');
            // We can import jwtDecode or access the role if login returns it. 
            // Let's rely on a smart redirect helper or just default to /dashboard for head/vice if we can check it.
            // Simpler: Fetch the role from the stored token.
            // Fetch the role from the stored token safely
            const payload = jwtDecode(token);
            const role = payload.role;

            if (from === '/') {
                if (role === 'head' || role === 'vice') {
                    navigate('/dashboard', { replace: true });
                } else {
                    navigate('/', { replace: true });
                }
            } else {
                navigate(from, { replace: true });
            }
        } catch (err) {
            setError('Неверное имя пользователя или пароль');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="w-full max-w-md space-y-8 bg-white p-8 rounded-xl shadow-lg border border-gray-100">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 tracking-tight">
                        Вход в систему
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        Для преподавателей и администрации
                    </p>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="space-y-4 rounded-md shadow-sm">
                        <Input
                            id="username"
                            name="username"
                            type="text"
                            required
                            label="Username"
                            placeholder="Введите логин"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <Input
                            id="password"
                            name="password"
                            type="password"
                            required
                            label="Password"
                            placeholder="Введите пароль"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    {error && (
                        <div className="text-sm text-red-600 text-center bg-red-50 p-2 rounded">
                            {error}
                        </div>
                    )}

                    <div>
                        <Button
                            type="submit"
                            className="w-full flex justify-center py-3"
                            disabled={loading}
                            variant="primary"
                        >
                            {loading ? 'Вход...' : 'Войти'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}
